import * as Yup from "yup";
import SubGroupModel from "../../models/products/subgroup-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { SelectField } from "../../core/select-field.component";
import { useEffect, useState } from "react";
import { useGetMainGroups } from "../../apiclient/product/useGetMainGroupApi";
import { useGetSubGroups } from "../../apiclient/product/useGetSubGroupApi";
import { useGetProductTax } from "../../apiclient/master/useGetProductTaxApi";


interface SubGroupEditProps {
    data: SubGroupModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
}

const SubGroupEntry: React.FC<SubGroupEditProps> = ({ ...props }) => {
    let { data, onClose ,isViewMode} = props;
    const title = data?.subGroupId > 0 ? "Edit Sub Group" : "Add Sub Group";

    const initialValue: SubGroupModel = {
        subGroupId: data?.subGroupId || 0,
        name: data?.name || '',
        shortName: data?.shortName || '',
        color: data?.color,
        mainGroupId: data?.mainGroupId || 0,
        productTaxId: data?.productTaxId ||0,
        sgstPercentage: data?.sgstPercentage,
        cgstPercentage: data?.cgstPercentage,
        igstPercentage: data?.igstPercentage,
        displayOrder: data?.displayOrder,
        isActive: data?.subGroupId > 0 ? data.isActive : true,
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string()
        .required("Required")
        .test("check-duplicate-name", "SubGroup name already exists", (value) => {
          // Ensure the value is compared in a case-insensitive manner
          return (
            value &&
            !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
            (data?.name && value === data.name) // Allow current name during update
          );
        }), 
        shortName: Yup.string()
        .required("Required")
        .test("check-duplicate-name", "ShortName name already exists", (value) => {
          // Ensure the value is compared in a case-insensitive manner
          return (
            value &&
            !existingShortName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
            (data?.shortName && value === data.shortName) // Allow current name during update
          );
        }), 
        });

    const [mainGroupData, setMainGroupData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedMainGroup } = useGetMainGroups();
    const [productTaxData, setProductTaxData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedProductTax } = useGetProductTax();

    const [existingName, setExistingName] = useState<string[]>([]);
    const [existingShortName,setExistingShortName] =useState<string[]>([]);
  const { data: fetchedSubGroup } = useGetSubGroups();

    useEffect(() => {

        
    if (fetchedSubGroup) {
        setExistingName(fetchedSubGroup.map((cat: any) => cat.name));
        setExistingShortName(fetchedSubGroup.map((cat:any)=>cat.shortName));
    }
        if (fetchedMainGroup) {
            const mappedMainGroup = fetchedMainGroup.map((mainGroup: any) => ({
                value: mainGroup.mainGroupId,
                label: mainGroup.name,
            }));
            setMainGroupData(mappedMainGroup);
        }
        if (fetchedProductTax) {
            const mappedProductTax = fetchedProductTax.map((productTax: any) => ({
                value: productTax.productTaxId,
                label: productTax.taxName,
            }));
            setProductTaxData(mappedProductTax);
        }
    }, [fetchedMainGroup,fetchedSubGroup,fetchedProductTax]);

    return (

        <>
            <FormikModelDialog
                width="60%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.PRODUCT}
                postRoute="SubGroup/SaveSubGroup"
                showAddAnother={true}
                isViewOnly ={isViewMode}
                isUpDateEntityDetails={data?.subGroupId > 0}
            >
                <div>
                    <div className="row">
                        <div className="col-3">
                            <InputField maxLength={100} label="Name *" name="name" />
                        </div>
                        <div className="col-3">
                            <InputField maxLength={100} label="Short Name" name="shortName" />
                        </div>
                        <div className="col-5">
                            <SelectField
                                label="Main Group"
                                name="mainGroupId" 
                                options={mainGroupData}
                            />
                        </div>
                        <div className="col-3">
                        <SelectField
                                label="Product Tax"
                                name="productTaxId"
                                options={productTaxData}
                                unSelectValue={0}
                            />                        </div>
                        <div className="col-3">
                            <InputField maxLength={3} label="SGST (%)" name="sgstPercentage" />
                        </div>
                        <div className="col-3">
                            <InputField maxLength={3} label="CGST (%)" name="cgstPercentage" />
                        </div>
                        <div className="col-3">
                            <InputField label="IGST (%)" name="igstPercentage" />
                        </div>
                        <div className="col-3">
                            <InputField label="Display Order" name="displayOrder" />
                        </div>
                        <div className="col-3">
                            <InputField label="Color" name="color" />

                        </div>
                        <div className="col-3">
                            <CheckboxField
                                label="Is Active?"
                                name="isActive"
                                checkstyle={CheckBoxStyle.Normal}
                            />
                        </div>
                    </div>
                </div>
            </FormikModelDialog>
        </>
    );
};

export default SubGroupEntry;